// extracted by mini-css-extract-plugin
module.exports = {"root":"Backdrop_root__1jq59","background":"Backdrop_background__2dl0L"};